import { API } from 'src/apis/apiWrapper';
import { AUTH_STATUS, IRole, extractRoles } from "../constants";

declare global {
    interface Window { cb: any; }
}
window.cb = window.cb || {};

function EplSession() {
    const onLogout = (logoutHandle: any) => {
        window.cb.core.iam.getEventBus().on(window.cb.core.iam.events.Logout, logoutHandle);
    };

    const checkLogin = async () => {
        let roles: IRole[] = [];
        let status: AUTH_STATUS = AUTH_STATUS.LOGGED_OUT;
        let isLoggedIn: boolean = false;
        let userInfo: any = undefined;

        let userInSession = window.cb.core.iam.getAuthSession();
        if (!userInSession || !userInSession.isLoggedIn) {
            await timeout(2000);
            userInSession = window.cb.core.iam.getAuthSession();
        }

        if (userInSession && userInSession.isLoggedIn && (new Date().getTime() < userInSession.expireTimeInMS)) {
            let token = window.cb.core.iam.getAuthorizationToken();
            //even though the Apricot has the user information, the Catapult JWT token may be not returned yet
            //give another try after delaying a couple of seconds.
            if (!token) { //getAuthorizationToken may not return token on time.
                await timeout(2000);
                token = window.cb.core.iam.getAuthorizationToken();
            }

            if (token) {
                const user = await API.post('Login', 'save?key=login', { 'userName': userInSession.basicProfile.userName });
                if (user && user.user && user.roles) {
                    roles = extractRoles(user.roles);
                    status = AUTH_STATUS.LOGGED_IN;
                    isLoggedIn = true;
                    userInfo = {
                        'firstName':  userInSession.basicProfile.firstName,
                        'lastName': userInSession.basicProfile.lastName,
                        'cognito:username': userInSession.basicProfile.userName,
                        'email': userInSession.basicProfile.emailAddress,
                        'cognito:groups': 'admin',
                        'roles': roles
                    };
                }
            } else {
                console.log("EplSession:checkLogin :cannot get catapult JWT token after 2 calls!");
            }
        } else
            console.log("AuthProvider: eplSession:checkLogin :no valid user session");

        return {
            status: status,
            isLoggedIn: isLoggedIn,
            userInfo: userInfo,
            roles: roles
        };
    };

    const timeout = (mills: any) => {
        return new Promise(resolve => setTimeout(resolve, mills));
    };

    const getAuthorizationToken = () => {
        const userInSession = window.cb.core.iam.getAuthSession();
        if (userInSession && userInSession.isLoggedIn && (new Date().getTime() < userInSession.expireTimeInMS)) {
            return window.cb.core.iam.getAuthorizationToken();
        }
        return null;
    };

    return {
        checkLogin,
        onLogout,
        getAuthorizationToken
    };
}

export default EplSession();
